/**
 * Checks if `value` is the [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types) of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, `new String('')`)
 *
 * @param {*} value The value to check.
 * @returns {Boolean} True if "value" is an object, else false.
 * @example
 *
 * isObject({});
 * // -> true
 *
 * isObject(function test() {});
 * // -> true
 *
 * isObject([1, 2, 3]);
 * // -> true
 *
 * isObject('Hello World!');
 * // -> false
 *
 * isObject(false);
 * // -> false
 *
 * isObject(new String('Hello world'));
 * // -> true
 *
 * isObject();
 * // -> false
 */
export const isObject = (value) => {
  var type = typeof value;
  return value != null && (type === 'object' || type === 'function');
};
